import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Navbar from '../Navbar/Navbar';
import { useMediaQuery } from '@mui/material';
import * as XLSX from 'xlsx';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import { useCarrito } from '../context/CarritoContext';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

const ProductoNegado = () => {
  const [proNegado, setProNegado] = useState([]);
  const { rol } = useCarrito();
  const isMobile = useMediaQuery('(max-width:600px)');
  const rowsWithId = proNegado.map((row, index) => ({
    id: index + 1,
    ...row
  }));
  const fechaActual = dayjs();
  const [fechaInicio, setFechaInicio] = useState(fechaActual);
  const [fechaFin, setFechaFin] = useState(fechaActual);
  const [zona, setZona] = useState('');
  const [tipo, setTipo] = useState('');

  const filasFiltradas = rowsWithId
    .filter((item) => {
      if (rol === 'Cliente') return true;
      if (!fechaInicio || !fechaFin) return true;

      const fechaItem = dayjs(item.fecha);

      const dentroRango =
        fechaItem.isAfter(fechaInicio.subtract(1, "day")) &&
        fechaItem.isBefore(fechaFin.add(1, "day"));

      const coincideZona = !zona || item.Zona === zona;
      const coincideTipo = !tipo || item.Tipo === tipo;

      return dentroRango && coincideZona && coincideTipo;
    })
    .map((item) => ({ id: item.id, ...item }));

  useEffect(() => {
    const fetchPedidos = async () => {
      try {
        const response = await fetch('https://bibliotecadlago.com/php/lista_productoNegado2.php');
        const data = await response.json();
        if (data.success) {
          setProNegado(data.productoNegado);
        } else {
          console.error('Error al obtener pedidos');
        }
      } catch (error) {
        console.error('Error de red:', error);
      }
    };

    fetchPedidos();
    const intervalo = setInterval(() => {
      fetchPedidos();
    }, 600000);

    return () => clearInterval(intervalo);
  }, []);

  const columnas = [
    { field: 'MSPN', headerName: 'MSPN', width: isMobile ? 70 : 80 },
    { field: 'descripcion', headerName: 'Descripcion', width: isMobile ? 250 : 300 },
    { field: 'estatus', headerName: 'Estatus', width: isMobile ? 70 : 80 },
    { field: 'Tipo', headerName: 'Tipo', width: isMobile ? 100 : 150 },
    { field: 'marca', headerName: 'Marca', width: 120 },
    { field: 'Cantidad', headerName: 'Cantidad', width: isMobile ? 70 : 80 },
    { field: 'Nombre', headerName: 'Nombre', width: 300 },
    { field: 'Asesor', headerName: 'Asesor', width: 200 },
    { field: 'Rol', headerName: 'Rol', width: 120 },
    { field: 'Zona', headerName: 'Zona', width: 200 },
    { field: 'Cliente', headerName: 'Cliente', width: 200 },
    { field: 'fecha', headerName: 'Fecha', width: 200 },

  ];

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filasFiltradas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ProductoNegado');

    XLSX.writeFile(workbook, 'Producto_Negado.xlsx');
  };

    const exportToExcelCompleto = () => {
    const worksheet = XLSX.utils.json_to_sheet(rowsWithId);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'ProductoNegado');

    XLSX.writeFile(workbook, 'Producto_Negado.xlsx');
  };

  const columnasZona = [
    { field: "Zona", headerName: "Zona", width: 280 },
    { field: "marca", headerName: "marca", width: 130 },
    { field: "total_cantidad", headerName: "Total de llantas", width: 130 },
  ];

  const resumenPorZona = Object.values(
    filasFiltradas.reduce((acc, item) => {
      const key = `${item.Zona}-${item.marca}`;

      if (!acc[key]) {
        acc[key] = {
          Zona: item.Zona,
          marca: item.marca,
          total_cantidad: 0,
        };
      }

      acc[key].total_cantidad += Number(item.Cantidad);

      return acc;
    }, {})
  );

  const resumenPorMarca = Object.values(
    filasFiltradas.reduce((acc, item) => {
      const key = item.marca;

      if (!acc[key]) {
        acc[key] = {
          marca: item.marca,
          total_cantidad: 0,
        };
      }

      acc[key].total_cantidad += Number(item.Cantidad);

      return acc;
    }, {})
  );

  const columnasMarca = [
    { field: "marca", headerName: "Marca", width: 200 },
    { field: "total_cantidad", headerName: "Total de llantas", width: 200 },
  ];

  const top10Productos = Object.values(
    filasFiltradas.reduce((acc, item) => {
      const key = item.MSPN;

      if (!acc[key]) {
        acc[key] = {
          MSPN: item.MSPN,
          descripcion: item.descripcion,
          marca: item.marca,
          total_cantidad: 0,
        };
      }

      acc[key].total_cantidad += Number(item.Cantidad);

      return acc;
    }, {})
  )
    .sort((a, b) => b.total_cantidad - a.total_cantidad)
    .slice(0, 10);

  const columnasTop = [
    { field: "MSPN", headerName: "MSPN", width: 120 },
    { field: "descripcion", headerName: "Descripcion", width: 300 },
    { field: "marca", headerName: "Marca", width: 150 },
    { field: "total_cantidad", headerName: "Total Negadas", width: 150 },
  ];
  
  return (
    <>
      <Navbar />
      <Box p={4}>
        <Typography variant="h4" gutterBottom sx={{ color: '#cf1316', fontWeight: 'bold' }}>
          Producto Negado
        </Typography>
        <FormControl sx={{ minWidth: 250, mr: 2 }} >
          <InputLabel id="zona">Zona</InputLabel>
          <Select
            labelId="zona"
            id="zona"
            value={zona}
            label="zona"
            onChange={(e) => {
              setZona(e.target.value)
            }}
          >
            <MenuItem value={""}>Todas</MenuItem>
            <MenuItem value={"MAYOREO AGUASCALIENTES"}>MAYOREO AGUASCALIENTES</MenuItem>
            <MenuItem value={"MAYOREO ZACATECAS"}>MAYOREO ZACATECAS</MenuItem>
            <MenuItem value={"MAYOREO JALISCO"}>MAYOREO JALISCO</MenuItem>
            <MenuItem value={"MAYOREO PUERTO VALLARTA"}>MAYOREO PUERTO VALLARTA</MenuItem>
            <MenuItem value={"MAYOREO LEON"}>MAYOREO LEON</MenuItem>
            <MenuItem value={"MAYOREO COLIMA"}>MAYOREO COLIMA</MenuItem>
            <MenuItem value={"MAYOREO DURANGO"}>MAYOREO DURANGO</MenuItem>
          </Select>
        </FormControl >
        <FormControl sx={{ minWidth: 250, mr: 2 }} >
          <InputLabel id="tipo">Tipo</InputLabel>
          <Select
            labelId="tipo"
            id="tipo"
            value={tipo}
            label="tipo"
            onChange={(e) => {
              setTipo(e.target.value)
            }}
          >
            <MenuItem value={""}>Todas</MenuItem>
            <MenuItem value={"Producto Negado"}>Producto Negado</MenuItem>
            <MenuItem value={"No Disponible en Zona"}>No Disponible en Zona</MenuItem>
          </Select>
        </FormControl >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Fecha de inicio"
            format="DD/MM/YYYY"
            value={fechaInicio}
            sx={{ mb: 2, mr: 2 }}
            onChange={(e) => {
              setFechaInicio(e)
            }}
          />
          <DatePicker
            label="Fecha de fin"
            format="DD/MM/YYYY"
            value={fechaFin}
            onChange={(e) => {
              setFechaFin(e)
            }}
            sx={{ mb: 2, mr: 2 }}
          />
        </LocalizationProvider>

        <Button variant="contained" color="primary" onClick={exportToExcel} sx={{ mb: 2, mr: 2 }}>
          <FileDownloadIcon />Info Filtrado
        </Button>
        <Button variant="contained" color="primary" onClick={exportToExcelCompleto} sx={{ mb: 2 }}>
          <FileDownloadIcon /> Info Completa
        </Button>

        <Box sx={{ height: 600, width: '100%' }}>
          <DataGrid
            rows={filasFiltradas}
            columns={columnas}
            pageSize={10}
            rowsPerPageOptions={[5, 10, 20]}
            disableSelectionOnClick
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 4,
          flexWrap: "wrap",
          mt: 4,
          mb: 4
        }}
      >
        <Paper
          elevation={4}
          sx={{
            width: "45%",
            minWidth: 350,
            p: 3,
            borderRadius: 3,
            mb: 3
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2} align="center">
            Reporte por Zona
          </Typography>

          <DataGrid
            rows={resumenPorZona.map((row, index) => ({
              id: index,
              ...row
            }))}
            columns={columnasZona}
            autoHeight
            hideFooter
          />
        </Paper>

        <Paper
          elevation={4}
          sx={{
            width: "45%",
            minWidth: 350,
            p: 3,
            borderRadius: 3,
            mb: 3
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2} align="center">
            Reporte por Marca
          </Typography>

          <DataGrid
            rows={resumenPorMarca.map((row, index) => ({
              id: index,
              ...row
            }))}
            columns={columnasMarca}
            autoHeight
            hideFooter
          />
        </Paper>
      </Box>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 2, mb: 4 }}>
        <Paper
          elevation={4}
          sx={{
            width: "80%",
            maxWidth: 900,
            p: 3,
            borderRadius: 3,
            mx: "auto"
          }}
        >
          <Typography variant="h6" fontWeight="bold" mb={2} align="center">
            Top 10 Productos Más Negados
          </Typography>

          <DataGrid
            rows={top10Productos.map((row, index) => ({
              id: index,
              ...row
            }))}
            columns={columnasTop}
            autoHeight
            hideFooter
          />
        </Paper>
      </Box>
    </>
  );
};

export default ProductoNegado;
